AuthRoute = require 'mixins/authenticated-route'

App.RestaurantsCreateRoute = Em.Route.extend AuthRoute,
  model: ->
    model = @store.createRecord 'restaurant',
      # todo i18n
      name: 'Новый ресторан'
      organization: @get('session').get('currentOrganization')
      is_running: true


  controllerName: 'restaurantsRestaurant'

  renderTemplate: ->
    @render 'restaurants.restaurant'
